import { useI18n } from "@/context/I18nContext";

// Slim luxury announcement bar (deep blackberry) sitting above the light header.
// On phones the messages auto-scroll (marquee) so nothing is cropped; on larger
// screens they sit centred and static.
export const ShippingBanner = () => {
  const { t } = useI18n();
  const items = [t("banner.shipping"), t("banner.official"), t("banner.returns")];

  const Group = ({ hidden = false }) => (
    <div className="flex shrink-0 items-center gap-7 pr-7" aria-hidden={hidden}>
      {items.map((label, i) => (
        <span key={i} className="flex items-center gap-7 whitespace-nowrap">
          <span>{label}</span>
          <span className="h-1 w-1 rounded-full bg-boomerang" />
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="shipping-trust-banner"
      className="overflow-hidden bg-header text-white/90 text-[10.5px] font-medium uppercase tracking-[0.18em]"
    >
      {/* Phones & tablets: seamless auto-scrolling marquee (duplicated track for a clean loop) */}
      <div className="marquee-viewport overflow-hidden py-2 lg:hidden">
        <div className="flex w-max animate-marquee will-change-transform">
          <Group />
          <Group hidden />
        </div>
      </div>

      {/* Desktop: centred static row (only where there is room) */}
      <div className="container-site hidden flex-wrap items-center justify-center gap-x-7 gap-y-1 py-2 lg:flex">
        {items.map((label, i) => (
          <span key={i} className="flex items-center gap-7 whitespace-nowrap">
            <span>{label}</span>
            {i < items.length - 1 && <span className="h-1 w-1 shrink-0 rounded-full bg-boomerang" />}
          </span>
        ))}
      </div>
    </div>
  );
};
